<header class="app-header" [class.scrolled]="isScrolled" [class.menu-open]="isMobileMenuOpen">
  <div class="container">
    <nav class="row align-items-center">
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 logo-col">
        <div class="logo-container">
          <a class="logo" [routerLink]="['/']"><img src="/assets/images/dryo_cleaners.svg" alt="Dryo logo"></a>
        </div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-6 col-xs-12 menu-col">
        <button type="button" class="menu-toggle" (click)="toggleMobileMenu()" [attr.aria-expanded]="isMobileMenuOpen"
          aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul class="menu" [class.mobile-open]="isMobileMenuOpen">
          <li><a href="" (click)="navigateToSection('services', $event)" [class.active]="isMenuActive('services')">Services</a></li>
          <li><a [routerLink]="['/pricing']" (click)="onMenuItemClick()" [class.active]="isMenuActive('pricing')">Pricing</a></li>
          <li><a href="" (click)="navigateToSection('location', $event)" [class.active]="isMenuActive('location')">Visit Us</a></li>
          <li><a [routerLink]="['/contact']" (click)="onMenuItemClick()" [class.active]="isMenuActive('contact')">Contact</a></li>
        </ul>
      </div>
    </nav>
  </div>
</header>
